import type { CheckoutOption } from './types';

export const isVenmoOption = (option: CheckoutOption): boolean =>
  option.label.toLowerCase() === 'venmo';
